export const Routes = {
  HOME: '/',
  LOGIN: '/login',
  DELETE_ACCOUNT: '/delete-account',
  REGISTER: '/register',
  CONFIRMATION: '/confirmation',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',
  BEERS: '/beers',
  BEERS_NEW: '/beers/new',
  BEERS_VIEW: '/beers/view',
  BEERS_EDIT: '/beers/edit',
  POST_ARCHIVE: '/post-archive',
  PUB_PAGE: '/pub',
  SWITCH_PUB: '/switch-pub',
  PUB_PAGES: '/pub-pages',
  PUB_PAGES_NEW: '/pub-pages/new',
  PUB_PAGES_VIEW: '/pub-pages/view',
  PUB_PAGES_EDIT: '/pub-pages/edit',
  EDITORS: '/editors',
  EDITORS_VIEW: '/editors/view',
  EDITORS_EDIT: '/editors/edit',
  BREWERIES: '/breweries',
  BREWERIES_NEW: '/breweries/new',
  BREWERIES_EDIT: '/breweries/edit',
  BREWERIES_VIEW: '/breweries/view',
  BEER_STYLES: '/beer-styles',
  BEER_STYLES_NEW: '/beer-styles/new',
  BEER_STYLES_EDIT: '/beer-styles/edit',
  BEER_STYLES_VIEW: '/beer-styles/view',
  INVITE: '/invite',
  DOWNLOAD_APP: '/download-app',
  POST_GENERATOR: '/post-generator',
  PUB: '/pub',
  PUB_EDIT: '/pub/edit',
  BEERS_MANAGER: '/beers-manager',
};
